import type { CellPosition } from "./GridCell";

export interface EditSelection {
    editingPos: CellPosition | null;
    focusPos: CellPosition[] | null;
    // The printable character the user typed to start editing, or null when
    // editing was entered by click / Enter. Popup-based cells (e.g. link cells)
    // read it to seed their search with that first character — otherwise the
    // keystroke that opens the popup is lost.
    editInitialKey: string | null;
}

function copy(pos: CellPosition | null): CellPosition | null {
    return pos ? { rowId: pos.rowId, column: pos.column } : null;
}

/**
 * Computes the focus/edit state for entering edit mode at `position`.
 *
 * `initialKey` carries the character that initiated the edit (null for
 * click/Enter). It is propagated through the store so a link cell can pre-fill
 * its relation search with the first typed letter instead of dropping it.
 */
export function enterEdit(position: CellPosition | null, initialKey: string | null = null): EditSelection {
    return {
        editingPos: copy(position),
        focusPos: position ? [copy(position)!] : null,
        editInitialKey: initialKey,
    };
}
